"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.areSetEqual = exports.isServerSide = void 0;
const isServerSide = () => typeof window === 'undefined';
exports.isServerSide = isServerSide;
const areSetEqual = (as, bs) => {
    if (as.size !== bs.size) {
        return false;
    }
    for (const a of as) {
        if (!bs.has(a)) {
            return false;
        }
    }
    return true;
};
exports.areSetEqual = areSetEqual;
